var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AModal",
    {
      staticClass: "gallery-video-modal",
      attrs: { size: "xl" },
      on: {
        modalhidden: function ($event) {
          return _vm.$emit("modalToggled")
        },
      },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      _c("div", { staticClass: "embed-responsive embed-responsive-16by9" }, [
        _c("iframe", {
          staticClass: "embed-responsive-item",
          attrs: {
            id: "video",
            src: _vm.src,
            allowscriptaccess: "always",
            allow: "autoplay",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }